module.exports = __webpack_public_path__ + "img/41_20.9d8884cd.png";